import classnames from 'classnames'

class FormatText {
  /**
   * @static
   * @param {String} svg
   * @returns
   * @memberof FormatText
   */
  static formatSVGBase64(svg: String) {
    if (typeof svg !== 'string') return ''

    return svg.split('"')[1]
  }

  static desableLabelField(bool: boolean) {
    return classnames(
      'form__field__label',
      bool && 'form__field__label__isDisabled',
    )
  }
}

export default FormatText
